import { render, staticRenderFns } from "./stockmanagement.vue?vue&type=template&id=85f496c8&scoped=true&"
import script from "./stockmanagement.vue?vue&type=script&lang=js&"
export * from "./stockmanagement.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./stockmanagement.vue?vue&type=style&index=1&id=85f496c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f496c8",
  null
  
)

export default component.exports